const AUTH_TOKENS_KEY = 'auth_tokens'

export const getAccessToken = () => {
  if (typeof window === 'undefined') return null

  const legacyToken = localStorage.getItem('token')
  if (legacyToken) return legacyToken

  const rawAuthTokens = localStorage.getItem(AUTH_TOKENS_KEY)
  if (!rawAuthTokens) return null

  try {
    const parsedAuthTokens = JSON.parse(rawAuthTokens)
    return parsedAuthTokens?.access_token || null
  } catch (_) {
    return null
  }
}
